var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3906 5.43164C16.3498 5.30626 16.2704 5.197 16.1638 5.11947C16.0572 5.04194 15.9287 5.00012 15.7969 5H14.375V2.8125C14.375 2.4668 14.0957 2.1875 13.75 2.1875H6.25C5.9043 2.1875 5.625 2.4668 5.625 2.8125V5H4.20312C4.07121 4.99982 3.94264 5.04152 3.83593 5.11909C3.72923 5.19666 3.6499 5.3061 3.60938 5.43164L2.1875 9.80469V17.1875C2.1875 17.5332 2.4668 17.8125 2.8125 17.8125H17.1875C17.5332 17.8125 17.8125 17.5332 17.8125 17.1875V9.80469L16.3906 5.43164ZM7.03125 3.59375H12.9688V5H7.03125V3.59375ZM16.4062 16.4062H3.59375V10.0273L4.77148 6.40625H15.2285L16.4062 10.0273V16.4062ZM12.7344 11.1719H10.625V9.0625C10.625 8.97656 10.5547 8.90625 10.4688 8.90625H9.53125C9.44531 8.90625 9.375 8.97656 9.375 9.0625V11.1719H7.26562C7.17969 11.1719 7.10938 11.2422 7.10938 11.3281V12.2656C7.10938 12.3516 7.17969 12.4219 7.26562 12.4219H9.375V14.5312C9.375 14.6172 9.44531 14.6875 9.53125 14.6875H10.4688C10.5547 14.6875 10.625 14.6172 10.625 14.5312V12.4219H12.7344C12.8203 12.4219 12.8906 12.3516 12.8906 12.2656V11.3281C12.8906 11.2422 12.8203 11.1719 12.7344 11.1719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPharmacy);
export default __webpack_public_path__ + "static/media/ic-pharmacy.b8fb6c7af8eab2c3b6e07d08a0e82945.svg";
export { ForwardRef as ReactComponent };